import {useLiveQuery} from 'dexie-react-hooks';
import {useConnectivity} from 'src/offline/useConnectivity';
import {readSnapshot} from 'src/offline/offlineQuery';
import {getReadySession} from 'src/offline/offlineSessionManager';
import {useAppSelector} from 'src/redux/hooks';
import {FORMS_CONTEXT_KEY} from './snapshotKeys';

/**
 * Live availability of a cached forms reference section: `undefined` while
 * online or resolving, `false` when missing or captured under another scope.
 */
export const useOfflineSectionAvailable = (
  key: string,
  contextKey: string = FORMS_CONTEXT_KEY
): boolean | undefined => {
  const {isOffline} = useConnectivity();
  const scopeId = useAppSelector(state => state.projectScope.scope?.id);

  return useLiveQuery(async () => {
    if (!isOffline) return undefined;
    const session = await getReadySession(contextKey);
    if (!session) return false;
    const snapshot = await readSnapshot(session.id, key);
    if (!snapshot) return false;
    const section = snapshot.data as {scopeProjectId?: number} | undefined;
    return (section?.scopeProjectId ?? undefined) === (scopeId ?? undefined);
  }, [isOffline, key, contextKey, scopeId]);
};
